import InnerHTML from "dangerously-set-html-content";
import { t } from "@/i18n-js/instance";
import type { QuizAttempt } from "@/react/types/QuizAttempt";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";

interface QuizResultProps {
  lastAttempt: QuizAttempt;
  setIsSubmitEnabled: (isSubmitEnabled: boolean) => void;
  setLastAttempt: (attempt: QuizAttempt | null) => void;
}
export const QuizResult = ({
  lastAttempt,
  setLastAttempt,
  setIsSubmitEnabled,
}: QuizResultProps) => (
  <div className="border-primary flex flex-col-reverse rounded-lg border p-4 sm:flex-row sm:p-8">
    <div className="flex w-full flex-col items-start border-t pr-0 pt-4 sm:w-1/2 sm:border-t-0 sm:pr-4 sm:pt-0">
      <Typography.LabelMd weight="medium">
        <InnerHTML
          html={t(
            `courses.view_lesson.quiz_result.${lastAttempt.result}_message`,
          )}
        />
      </Typography.LabelMd>
      <Button
        type="button"
        variant={lastAttempt.result === "failed" ? "circle" : "secondary"}
        className="mt-4"
        onClick={() => {
          setLastAttempt(null);
          setIsSubmitEnabled(false);
        }}
      >
        {t("courses.view_lesson.retake_quiz")}
      </Button>
    </div>
    <div className="flex w-full justify-between pb-4 pl-0 sm:w-1/2 sm:pb-0 sm:pl-4">
      <div className="flex w-full flex-col gap-2">
        <Typography.LabelSm weight="semibold">
          {t("courses.view_lesson.quiz_result.score")}
        </Typography.LabelSm>
        <Typography.TitleXxl size="text-3xl sm:text-5xl">
          {lastAttempt.grade}%
        </Typography.TitleXxl>
      </div>
      <div className="flex w-full flex-col gap-2">
        <Typography.LabelSm weight="semibold">
          {t("courses.view_lesson.quiz_result.correct_answers")}
        </Typography.LabelSm>
        <Typography.TitleXxl size="text-3xl sm:text-5xl">
          {t("courses.view_lesson.quiz_result.correct_answers_count", {
            correct: lastAttempt.correct_responses,
            total: lastAttempt.questions.length,
          })}
        </Typography.TitleXxl>
      </div>
    </div>
  </div>
);
